import React, { Component } from "react";
import {
  TabsCustom,
  TabsCustomBody,
  TabsCustomHeader,
  TabsCustomItem,
  TabsCustomMenu,
} from "ui-kit-ck-consultant";

import CardPerformance from "../general/CardPerformance";
import CardLabelRSE from "../../components/performances/CardLabelRSE";

import AuthContext from "../../context/AuthContext";

import {
  formatCoutPerformance,
  formatDelaiPerformance,
  formatProductionPerformance,
  formatQualitePerformance,
  formatGlobalePerformance,
} from "./performanceDataFormatters";

import {
  formatRSEData,
  formatRSEDataEAD,
  RSE_PROPERTIES,
  RSE_PROPERTIES_EAD,
  hasAllRequiredProperties,
} from "./rseHelpers";

export default class PerformanceDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuTabs: [],
      index: 0,
    };
  }

  static contextType = AuthContext;

  setData = (idx) => {
    if (!this.props.perf) {
      return { data: null, dataDoughnut: null, dataTab: null, dataTwo: null };
    }

    const { perf, type, isPrecisia, typeSearch } = this.props;

    // Performance coût
    if (idx === 0) {
      return formatCoutPerformance(perf, type, isPrecisia, typeSearch);
    }

    // Performance délai
    if (idx === 1) {
      return formatDelaiPerformance(perf, type, typeSearch);
    }

    // Performance production
    if (idx === 2) {
      return formatProductionPerformance(perf, typeSearch);
    }

    // Performance qualité
    if (idx === 3) {
      return formatQualitePerformance(perf, type, typeSearch);
    }

    // Performance globale (idx 4 ou 5 selon le groupe)
    if ((idx === 5 && this.context.group === 1) || idx === 4) {
      return formatGlobalePerformance(perf, typeSearch);
    }

    return { data: null, dataDoughnut: null, dataTab: null, dataTwo: null };
  };

  getLabelRSEData = () => {
    const { perf, type } = this.props;

    if (!perf?.performance_RSE) {
      return [];
    }

    // Type 1 : données RSE standard
    if (type === 1) {
      if (!hasAllRequiredProperties(perf.performance_RSE, RSE_PROPERTIES)) {
        return [];
      }
      return formatRSEData(perf.performance_RSE);
    }

    // Type 2 : données RSE EAD
    if (type === 2) {
      if (!hasAllRequiredProperties(perf.performance_RSE, RSE_PROPERTIES_EAD)) {
        return [];
      }
      return formatRSEDataEAD(perf.performance_RSE);
    }

    return [];
  };

  getMenuTabs = () => {
    const { perf } = this.props;

    if (!perf) {
      return [];
    }

    const baseTabs = [
      "Performance coût",
      "Performance délai",
      "Performance production",
      "Performance qualité",
    ];

    if (this.context.group === 1 && perf.performance_RSE) {
      return [...baseTabs, "Label RSE", "Performance globale"];
    }

    return [...baseTabs, "Performance globale"];
  };

  render() {
    const menuTabs = this.getMenuTabs();
    const labelRSE = this.getLabelRSEData();

    const isRSETab = (idx) => {
      return idx === 4 && this.context.group === 1 && this.props.type !== 3;
    };

    return (
      <TabsCustom>
        {this.props.perf ? (
          <>
            <TabsCustomHeader className={"mt-10 mt-30-xl"}>
              {menuTabs.map((title, key) => (
                <TabsCustomMenu
                  disabled={this.props.isLoader}
                  key={key}
                  title={title}
                  active={this.state.index === key}
                  onClick={() => this.setState({ index: key })}
                />
              ))}
            </TabsCustomHeader>
            <TabsCustomBody noCard className="flex-column gap-20">
              {menuTabs.map((title, idx) => {
                const performanceData = this.setData(idx);

                return (
                  <TabsCustomItem
                    active={this.state.index === idx || this.props.force}
                    key={idx}
                  >
                    {isRSETab(idx) ? (
                      <CardLabelRSE label={labelRSE} />
                    ) : (
                      <CardPerformance
                        data={performanceData.data}
                        dataTwo={performanceData.dataTwo}
                        dataDoughnut={performanceData.dataDoughnut}
                        dataTab={performanceData.dataTab}
                        type={this.props.type}
                        tab={title}
                        isPrecisia={this.props.isPrecisia}
                      />
                    )}
                  </TabsCustomItem>
                );
              })}
            </TabsCustomBody>
          </>
        ) : null}
      </TabsCustom>
    );
  }
}
